// Primitive 5 — Table.
// Les colonnes numériques passent en `--mono` avec chiffres tabulaires
// et alignement à droite : un tableau de prix en proportionnel ne se
// lit pas. Marquer une colonne : `{ key, label, numeric: true }`.

export function Table({ columns, rows, getRowKey, caption, empty }) {
  if (!rows?.length && empty) return empty;

  return (
    <div className="table-wrap">
      <table className="table">
        {caption ? <caption className="sr-only">{caption}</caption> : null}
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} scope="col" className={col.numeric ? 'num' : undefined}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={getRowKey ? getRowKey(row, i) : (row.id ?? i)}>
              {columns.map((col) => (
                <td key={col.key} className={col.numeric ? 'num' : undefined}>
                  {/* L'INDEX est passé au rendu : sans lui, une colonne
                      d'actions ne peut désigner sa ligne que par une
                      valeur — et deux lignes peuvent porter la même le
                      temps d'une frappe. Argument optionnel : les
                      colonnes qui l'ignorent ne changent pas. */}
                  {col.render ? col.render(row, i) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
